/**
 * A list-group pill — tinted background of the group's color with a solid
 * dot, the mock's .gtag idiom.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

interface Props {
  name: string;
  color: string;
}

export const GroupChip: FC<Props> = ({ name, color }) => (
  <span
    title={name}
    className="inline-flex max-w-[180px] items-center gap-1.5 rounded-full border px-2 py-px text-[11px] font-medium"
    style={{
      backgroundColor: `${color}24`,
      borderColor: `${color}55`,
    }}
  >
    <span
      className="h-1.5 w-1.5 shrink-0 rounded-full"
      style={{ backgroundColor: color }}
    />
    <span className="truncate">{name}</span>
  </span>
);
